import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { SignupComponent } from './pages/signup/signup.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, title: 'emjo-oauth — Multi-tenant OAuth/OIDC platform' },
  { path: 'signup', component: SignupComponent, title: 'Sign up — emjo-oauth' },
  // Story 31.4 — the brand-site's first lazy route: the Documentation hub.
  { path: 'docs', loadChildren: () => import('./pages/docs/docs.routes').then(m => m.DOCS_ROUTES) },
  { path: '**', redirectTo: '' },
];
